// extracted by mini-css-extract-plugin
export default {"root":"style_root__spM4g","title":"style_title__i4vGV","label":"style_label__m5cFW","image":"style_image__Umq50"};